import React, { memo, useEffect, useLayoutEffect } from 'react';
import { useRouteMatch } from 'react-router-dom';

import { Routes } from '@components';
import {
  SYSTEM_SETTING_PAGE_CLASSNAME,
  SYSTEMSETTING_SEGMENTS_MENU,
  SYSTEMSETTING_TITLES,
} from '@model';
// import PropTypes from 'prop-types';

import Portal from './systemSettingPortal';

// import '@style/modules/systemSettings.scss';
import '../../styles/modules/systemSettings.scss';
import { handleNameInitialsModuleBack } from '@utils/history';
import { setSessionStorage } from '@utils/windowUtil';

const hasSegment = (currentSegment) =>
  SYSTEMSETTING_SEGMENTS_MENU.filter(
    (menu) => menu.path === `/${currentSegment}`,
  ).length > 0;

const getPageTitle = (segments) =>
  SYSTEMSETTING_TITLES[segments] || SYSTEMSETTING_TITLES.default;

const getPageClassName = (segments) =>
  SYSTEM_SETTING_PAGE_CLASSNAME[segments] || '';

const Header = memo(({ currentSegment, history }) => {
  const resetTitle = () => {
    const titleElem = document.getElementById('project-form-title');
    titleElem.style.display = 'flex';
  };

  const handleGoBack = () => {
    resetTitle();

    if (currentSegment === 'userGuide') {
      history.push('/settings');
      return;
    }
    // const from = getSessionStorage('systemSettingsFrom');
    // if (currentSegment) {
    //   history.goBack();
    // } else if (from) {
    //   const { path, state } = JSON.parse(from) || {};
    //   history.push(path, state);
    //   window.SessionStorage.removeItem('systemSettingsFrom');
    // } else {
    //   history.goBack();
    // }
    handleNameInitialsModuleBack(history, currentSegment);
  };
  return (
    <>
      <span className="dd-back-btn" onClick={handleGoBack}>
        <span className="appkiticon icon-left-chevron-fill a-font-12" /> Back
      </span>
      <div className="project-form-title" id="project-form-title">
        {getPageTitle(currentSegment)}
      </div>
    </>
  );
});

function Settings({
  routes,
  match: { path },
  history,
  location: { state = {} },
}) {
  const { params: { currentSegment } = {} } =
    useRouteMatch(`${path}/:currentSegment`) || {};

  useLayoutEffect(() => {
    if (currentSegment && !hasSegment(currentSegment)) {
      history.replace(path);
    }
  }, [currentSegment]);

  useEffect(() => {
    if (state.from) {
      setSessionStorage('systemSettingsFrom', JSON.stringify(state.from));
    }
  }, [state.from]);

  return (
    <div
      className={`page-wrapper system-setting-wrapper project ${getPageClassName(
        currentSegment,
      )}`}
    >
      <Header currentSegment={currentSegment} history={history} />
      {!currentSegment && <Portal rootPath={path} />}
      <Routes routeData={routes} rootPath={path} />
    </div>
  );
}

Settings.propTypes = {};

export default memo(Settings);
